/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Text_LabelInputs */

const en_import_text_label = /** @type {(inputs: Import_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipe text`)
};

const de_import_text_label = /** @type {(inputs: Import_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezepttext`)
};

/**
* | output |
* | --- |
* | "Recipe text" |
*
* @param {Import_Text_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_text_label = /** @type {((inputs?: Import_Text_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Text_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_text_label(inputs)
	return en_import_text_label(inputs)
});